/** 
 * Copyright © INOVUA TRADING.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _join = _interopRequireDefault(require("../../../common/join"));
var Expander = function Expander(_ref) {
  var className = _ref.className,
    rootClassName = _ref.rootClassName,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 20 : _ref$size,
    onClick = _ref.onClick,
    fill = _ref.fill,
    rtl = _ref.rtl;
  return _react.default.createElement("div", {
    className: "".concat(rootClassName, "__expander-wrapper")
  }, _react.default.createElement("div", {
    className: "".concat(rootClassName, "__expander-icon")
  }, _react.default.createElement("svg", {
    className: (0, _join.default)(className, "".concat(rootClassName, "__expander")),
    onClick: onClick,
    fill: fill,
    height: size,
    width: size / 2,
    viewBox: "0 0 5 10"
  }, rtl ? _react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M.262 4.738L4.368.632c.144-.144.379-.144.524 0C4.96.702 5 .796 5 .894v8.212c0 .204-.166.37-.37.37-.099 0-.193-.039-.262-.108L.262 5.262c-.145-.145-.145-.38 0-.524z"
  }) : _react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M4.738 5.262L.632 9.368c-.144.144-.379.144-.524 0C.04 9.298 0 9.204 0 9.106V.894C0 .69.166.524.37.524c.099 0 .193.039.262.108l4.106 4.106c.145.145.145.38 0 .524z"
  }))));
};
Expander.isExpander = true;
var _default = Expander;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./~/@inovua/reactdatagrid-community/packages/Menu/src/Expander.js
// module id = 695
// module chunks = 0